import React from 'react';

export const DetailProcessingText = ({ normalizedFacility, t }) => { // Change prop name
  let activeValue;
  if (normalizedFacility !== "") { // Use normalizedFacility
    activeValue = normalizedFacility;
  } else { 
    activeValue = "Los Angeles"; // Default fallback
  }

  let activeTitle;
  if (t) { // Check if t() function is available
    activeTitle = t('processing.processingFacility'); // Use localized string
  } else {
    // Fallback if t is not provided, though it should be
    activeTitle = "PROCESSING FACILITY"; 
  }

  return (
    <>
      <p className="spec-title">{activeTitle}</p>
      <p className="spec-value">{activeValue}</p>
    </>
  );
};